import api from './api';

/**
 * MY HUB (9/4/26) - a sales rep's per-clinic controls. Every response is the house envelope
 * ({ success, data }), so the payload is res.data.data. The server scopes everything: a rep gets the
 * clinics assigned to them, a clinic login its own (read-only, canManage:false), an admin every one.
 */
const hubService = {
  /** { data: HubClinic[], products: [{_id,name,sku}], canManage } */
  list: () => api.get('/hub/clinics'),
  /** false = this clinic's own logins may view orders but not create them. */
  setOrdering: (clinicId, orderingEnabled) =>
    api.put(`/hub/clinics/${clinicId}/ordering`, { orderingEnabled }),
  /** A list of product ids, or null for "all products". Never an empty list (the server refuses). */
  setAllowedProducts: (clinicId, allowedProductIds) =>
    api.put(`/hub/clinics/${clinicId}/products`, { allowedProductIds }),
};

export default hubService;
